import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { classNames } from '../../../../utils/classnames';

/**
 * @description Render memoized main layout component
 * @param {*} children
 * @returns {JSX.Element} Memoized main layout component
 */
export const Main = memo(function MemoizedMain({ children, className }) {
  return <div className={classNames('min-h-screen w-full', className)}>{children}</div>;
});

Main.propTypes = {
  children: PropTypes.any
};
